/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, formStyles, mixins, fonts } from '@blend/consumer-components';
import { IAttachment } from './types';
import { ActionButton } from '@components/ActionButton/ActionButton';

export namespace AttachmentCard {
  export interface Props {
    attachment: IAttachment;
  }
}

const styles = StyleSheet.create({
  cardWrapper: {
    ...formStyles.inputPadding(),
    ...mixins.globalBorderStyle,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  header: {
    fontWeight: fonts.weight.bold,
    color: colors.darkerGray,
    ...mixins.margin(0),
  },
  subHeader: {
    fontStyle: 'italic',
    color: colors.clayPlus3,
    ...mixins.margin(0),
  },
});

export const AttachmentCard: React.FC<AttachmentCard.Props> = ({ attachment }) => {
  const { header, downloadUrl, subHeader } = attachment;
  return (
    <div className={css(styles.cardWrapper)} data-it="AttachmentCard">
      <div>
        <p className={css(styles.header)}>{header}</p>
        <p className={css(styles.subHeader)}>{subHeader}</p>
      </div>
      <div>
        {downloadUrl && (
          <ActionButton
            data-dd-privacy="allow"
            sizing="sm"
            onClick={() => window.open(downloadUrl)}
            data-it="AttachmentCard-DownloadButton"
          >
            Download
          </ActionButton>
        )}
      </div>
    </div>
  );
};
